var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DxButton',{attrs:{"width":"100%","text":"SAVE","type":"success","styling-mode":"contained","validation-group":_vm.validationGroup},on:{"click":function($event){return _vm.onClick($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }